import { Route, Routes, useLocation } from 'react-router-dom'
import { SiteLayout } from '../layouts/SiteLayout'
import { MapPage } from '../pages/MapPage'
import type { Locale } from '../transport/types'

function MapRoute({ locale }: { locale: Locale }) {
  return <SiteLayout locale={locale}><MapPage locale={locale} /></SiteLayout>
}

function FallbackMapRoute() {
  const location = useLocation()
  const locale: Locale = location.pathname === '/en' || location.pathname.startsWith('/en/') ? 'en' : 'ar'
  return <MapRoute locale={locale} />
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MapRoute locale="ar" />} />
      <Route path="/en/" element={<MapRoute locale="en" />} />
      <Route path="*" element={<FallbackMapRoute />} />
    </Routes>
  )
}
